import { createFileRoute } from "@tanstack/react-router";
import TradeInCompletionFromHome from "@/features/tradein/pages/trade-in-completion-from-home/TradeInCompletionFromHome";

export const Route = createFileRoute("/$locale/$partner/_trade-in/trade-in-completion-from-home")({
	component: TradeInCompletionFromHome,
});
